export default {"src":"/_next/static/media/give-logo.b25851f0.svg","height":300,"width":860};